import React from "react";

const Stepper = ({ step, onStepClick }) => (
    <div className="w-full flex items-center justify-center mb-4">
        <div className="flex items-center w-full max-w-lg">
            {/* Step 1: Add Product */}
            <button
                type="button"
                onClick={() => onStepClick?.(0)}
                className="flex flex-col items-center flex-1"
                aria-label="Go to Add Product"
            >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 border-2 ${step === 0 ? 'bg-white border-brand-green shadow-md' : 'bg-gray-50 border-gray-300'} `}>
                    <svg className={`w-4 h-4 ${step === 0 ? 'text-brand-green' : 'text-gray-400'}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 4v16m8-8H4" strokeLinecap="round" /></svg>
                </div>
                <span className={`mt-1 text-[10px] md:text-xs font-medium transition-all duration-200 ${step === 0 ? 'text-brand-green' : 'text-gray-500'}`}>Add Product</span>
            </button>
            {/* Line */}
            <div className={`flex-1 h-0.5 mx-0.5 md:mx-1 transition-all duration-200 ${step > 0 ? 'bg-green-700' : 'bg-gray-300'}`} />
            {/* Step 2: Added */}
            <button
                type="button"
                onClick={() => onStepClick?.(1)}
                className="flex flex-col items-center flex-1"
                aria-label="Go to Pre-Release Cart"
            >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 border-2 ${step === 1 ? 'bg-white border-blue-500 shadow-md' : step > 1 ? 'bg-blue-50 border-blue-300' : 'bg-gray-50 border-gray-300'}`}>
                    <svg className={`w-4 h-4 ${step === 1 || step > 1 ? 'text-blue-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" strokeLinecap="round" /></svg>
                </div>
                <span className={`mt-1 text-[10px] md:text-xs font-medium transition-all duration-200 ${step === 1 ? 'text-blue-500' : 'text-gray-500'}`}>Added</span>
            </button>
            {/* Line */}
            <div className={`flex-1 h-0.5 mx-0.5 md:mx-1 transition-all duration-200 ${step > 1 ? 'bg-blue-500' : 'bg-gray-300'}`} />
            {/* Step 3: Submit */}
            <button
                type="button"
                onClick={() => onStepClick?.(2)}
                className="flex flex-col items-center flex-1"
                aria-label="Go to Submit Request"
            >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 border-2 ${step === 2 ? 'bg-white border-amber-500 shadow-md' : step > 2 ? 'bg-amber-50 border-amber-300' : 'bg-gray-50 border-gray-300'}`}>
                    <svg className={`w-4 h-4 ${step === 2 || step > 2 ? 'text-amber-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10 14l11-11M21 3l-7.5 18-3.5-7-7-3.5L21 3Z" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </div>
                <span className={`mt-1 text-[10px] md:text-xs font-medium transition-all duration-200 ${step === 2 ? 'text-amber-600' : 'text-gray-500'}`}>Submit</span>
            </button>
            {/* Line */}
            <div className={`flex-1 h-0.5 mx-0.5 md:mx-1 transition-all duration-200 ${step > 2 ? 'bg-amber-500' : 'bg-gray-300'}`} />
            {/* Step 4: List */}
            <button
                type="button"
                onClick={() => onStepClick?.(3)}
                className="flex flex-col items-center flex-1"
                aria-label="Go to My Pre-Releases"
            >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 border-2 ${step === 3 ? 'bg-white border-gray-700 shadow-md' : 'bg-gray-50 border-gray-300'}`}>
                    <svg className={`w-4 h-4 ${step === 3 ? 'text-gray-700' : 'text-gray-400'}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 6h16M4 10h16M4 14h16M4 18h16" strokeLinecap="round" /></svg>
                </div>
                <span className={`mt-1 text-[10px] md:text-xs font-medium transition-all duration-200 ${step === 3 ? 'text-gray-700' : 'text-gray-500'}`}>List</span>
            </button>
        </div>
    </div>
);

export default Stepper;
